import { Component, HostListener, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { AdminService } from 'src/app/core/services/admin-apis/admin.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-featured-guests',
  templateUrl: './featured-guests.component.html',
  styleUrls: ['./featured-guests.component.scss']
})
export class FeaturedGuestsComponent implements OnInit {
  customOptions: OwlOptions = {
    loop: false,
    mouseDrag: true,
    touchDrag: true,
    autoWidth: true,
    pullDrag: true,
    dots: true,
    merge: false,
    navSpeed: 700,
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 1
      },
      500:{
        items: 2
      },
      940: {
        items: 3
      },
      1200:{
        items: 4
      },

      1800: {
        items: 6
      }
    }
  }
  cinejoyHostsClass = "";
  constructor(private service: AdminService, private router: Router) { }

  featuredGuests: any = [];
  cinejoyHosts: any = [];

  ngOnInit(): void {
    setTimeout(() => {
      this.getCinejoyHosts()
      this.getFeaturedGuests()
    }, 1000)
  }

  getFeaturedGuests() {
    this.service.getFeaturedGuestsListByDate().subscribe((res: any) => {
      this.featuredGuests = res.sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());
      if ((this.featuredGuests.length % 2) <= 0) {
        this.cinejoyHostsClass = ((this.featuredGuests.length + 1) / 2) <= 0 ? 'black' : 'red';
      } else {
        this.cinejoyHostsClass = (this.featuredGuests.length / 2) <= 0 ? 'red' : 'black';
      }
    }, err => {
      console.log("Error");
    })
  }

  getCinejoyHosts() {
    this.service.getCinejoyHostsList().subscribe((res: any) => {
      this.cinejoyHosts = res;
    }, err => {

    })
  }

  onClickPrev(i: any) {
    (<any>$(`#${i}`)).carousel('next');
  }

  navigateToSpotlight() {
    this.router.navigate(['/cinejoy/premiere/lineup'])
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.getFeaturedGuests()
  }

}
